import { isSsr } from '@99designs/browser';
import { RedirectError } from '@99designs/routing';

export interface Param {
    key: string;
    value: string;
}

export function createRedirectUrl(url: string, params?: Param[]): string {
    if (!params) {
        return url;
    }

    const str: string[] = [];
    params.forEach((param) => {
        str.push(`${param.key}=${encodeURIComponent(param.value)}`);
    });

    return `${url}?${str.join('&')}`;
}

/**
 * @deprecated Use redirectTo from `@99designs/routing` instead.
 */
const redirectTo = (url: string, params?: Param[]) => {
    const parsedUrl = createRedirectUrl(url, params);

    if (isSsr()) {
        throw new RedirectError(parsedUrl);
    } else {
        window.location.assign(parsedUrl);
    }
    return null;
};

export default redirectTo;
